import gql from 'graphql-tag';

const VENDOR_LIST = gql`
  query Query {
    vendorList {
      vendor
    }
  }
`;

export default VENDOR_LIST;
